import Image from 'next/image';

import { ArticlesBlock } from '@/components/ArticlesBlock';
import { Sidebar } from '@/components/Layout/Sidebar';
import { SuggestArticle } from '@/components/SuggestArticle';
import coverImage from './assets/cover.png';
import logoImage from './assets/logo.svg';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <>
      <SuggestArticle />
      <div className={styles.mobileOnly}>
        <div>
          <ArticlesBlock className={styles.articlesBlock} />
        </div>
        <div className={styles.divider} />
        <div className={styles.imageWrapper}>
          <Image
            className={styles.coverImage}
            src={coverImage}
            alt="cover"
            height={348}
            width={309}
          />
          <Image
            className={styles.logo}
            src={logoImage}
            alt="logo"
            height={61}
            width={211}
          />
        </div>
        <div className={styles.divider} />
        <Sidebar className={styles.sidebar} withLogo={false} />
        <div className={styles.divider} />
        <p className={styles.copyright}>© Gangsta Media 2025</p>
      </div>
    </>
  );
}
